/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/schedulerobjects/scheduler_reporting.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    RuntimeError,
    RuntimeErrorFromJSON,
    RuntimeErrorToJSON,
    SchedulerobjectsJobReport,
    SchedulerobjectsJobReportFromJSON,
    SchedulerobjectsJobReportToJSON,
    SchedulerobjectsQueueReport,
    SchedulerobjectsQueueReportFromJSON,
    SchedulerobjectsQueueReportToJSON,
    SchedulerobjectsSchedulingReport,
    SchedulerobjectsSchedulingReportFromJSON,
    SchedulerobjectsSchedulingReportToJSON,
} from '../models';

export interface GetJobReportRequest {
    jobId: string;
}

export interface GetQueueReportRequest {
    queueName: string;
    verbosity?: number;
}

export interface GetSchedulingReportRequest {
    mostRecentForQueueQueueName?: string;
    mostRecentForJobJobId?: string;
    verbosity?: number;
}

/**
 * 
 */
export class SchedulerReportingApi extends runtime.BaseAPI {

    /**
     * Return the most recent scheduling report for each executor for the given job.
     */
    async getJobReportRaw(requestParameters: GetJobReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SchedulerobjectsJobReport>> {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling getJobReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/job/{jobId}/scheduler-report`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SchedulerobjectsJobReportFromJSON(jsonValue));
    }

    /**
     * Return the most recent scheduling report for each executor for the given job.
     */
    async getJobReport(requestParameters: GetJobReportRequest, initOverrides?: RequestInit): Promise<SchedulerobjectsJobReport> {
        const response = await this.getJobReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return the most recent report scheduling for each executor for the given queue.
     */
    async getQueueReportRaw(requestParameters: GetQueueReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SchedulerobjectsQueueReport>> {
        if (requestParameters.queueName === null || requestParameters.queueName === undefined) {
            throw new runtime.RequiredError('queueName','Required parameter requestParameters.queueName was null or undefined when calling getQueueReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.verbosity !== undefined) {
            queryParameters['verbosity'] = requestParameters.verbosity;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/queue/{queueName}/scheduler-report`.replace(`{${"queueName"}}`, encodeURIComponent(String(requestParameters.queueName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SchedulerobjectsQueueReportFromJSON(jsonValue));
    }

    /**
     * Return the most recent report scheduling for each executor for the given queue.
     */
    async getQueueReport(requestParameters: GetQueueReportRequest, initOverrides?: RequestInit): Promise<SchedulerobjectsQueueReport> {
        const response = await this.getQueueReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return the most recent scheduling report for each executor.
     */
    async getSchedulingReportRaw(requestParameters: GetSchedulingReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SchedulerobjectsSchedulingReport>> {
        const queryParameters: any = {};

        if (requestParameters.mostRecentForQueueQueueName !== undefined) {
            queryParameters['mostRecentForQueue.queueName'] = requestParameters.mostRecentForQueueQueueName;
        }

        if (requestParameters.mostRecentForJobJobId !== undefined) {
            queryParameters['mostRecentForJob.jobId'] = requestParameters.mostRecentForJobJobId;
        }

        if (requestParameters.verbosity !== undefined) {
            queryParameters['verbosity'] = requestParameters.verbosity;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/scheduling-report`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SchedulerobjectsSchedulingReportFromJSON(jsonValue));
    }

    /**
     * Return the most recent scheduling report for each executor.
     */
    async getSchedulingReport(requestParameters: GetSchedulingReportRequest = {}, initOverrides?: RequestInit): Promise<SchedulerobjectsSchedulingReport> {
        const response = await this.getSchedulingReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
